import { booleanAttribute, Component, input, output } from '@angular/core';

// A button that answers every click - a stepper, a zoom or page arrow - for the few buttons the
// app-wide double-click guard (ClickGuardService) must leave alone. Every other button is guarded
// by default and needs nothing.
//
// Why a component (Chris, PR 2450): the guard's opt-out, `data-repeat-click`, is then written in
// ONE place - this template - instead of on each button or on a wrapper around a group of them.
// A screen uses `<app-repeat-click-button>` and never writes the attribute itself.
//
// The host is `display: contents`, so the button lays out exactly as a plain one in the same
// place would. ⚠️ The inner button is this component's own element, so the CONSUMER's component
// stylesheet does not reach it: style it through global classes passed in `buttonClass`, or from
// the consumer with `::ng-deep` under one of its own elements (the TmsAdmin PDF viewer does).
//
// Bind `(clicked)`, not `(click)`: it is emitted from the button's own handler, so a disabled
// button never emits.
@Component({
  selector: 'app-repeat-click-button',
  templateUrl: './repeat-click-button.component.html',
  styleUrl: './repeat-click-button.component.scss',
})
export class RepeatClickButtonComponent {
  public readonly buttonClass = input('');
  // booleanAttribute, so a bare `disabled` attribute disables it as it would a native button.
  public readonly disabled = input(false, { transform: booleanAttribute });
  // The tooltip (the button's `title`) and its accessible name (`aria-label`). Named differently
  // from the native attributes so the host element never carries a second title or aria-label.
  public readonly tooltip = input<string>();
  public readonly label = input<string>();
  public readonly clicked = output<void>();
}
